/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Table as MuiTable, TableContainer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { getLSItem, keysLS, setLSItem } from 'util/localStorageProvider';
import TableBody from './TableBody';
import TableHead from './TableHead';
import TablePagination from './TablePagination';

const styles = () => ({
  root: {
    width: '100%',
    overflow: 'auto',
  },
  table: {
    // minWidth: 1020,
  },
  tableCell: {
    textAlign: 'left',
  },
});

const getTableParams = (name) => {
  let result = {};

  if (name === 'supplier-table' && getLSItem(keysLS.supplierListTableParams)) {
    result = JSON.parse(getLSItem(keysLS.supplierListTableParams));
  }

  return result;
};
const getRowsPerPageOptions = (length) => {
  let result = [];
  const defaultOptions = [10, 25, 50, 100];

  if (length > 0 && length < 100) {
    result = defaultOptions.filter((rows) => rows <= length);
  }

  if (length >= 100) result = defaultOptions;

  return result;
};

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
    : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
}

const Table = (props) => {
  const {
    classes,
    columnData,
    data,
    keyColumn,
    name = null,
    hover,
    noEmptyRows,
    noPagination,
    orderColumn,
    paginationProps,
    rowsPerPage: rowsPerPageProps,
    onRowClick,
    toolColumn,
    toolMenu,
    usingCheckbox,
    usingForFactoryAudit,
    titleTableHead,
    handleCustomSort,
    showingTableHeader,
    customEmptyTableBody,
    positionExpand = 'left',
    handleSort = () => {},
    usingExpandLayout,
    defaultExpanded = false,
    onChangePage = () => {},
    onChangeRowsPerPage = () => {},
  } = props;

  const [state, setState] = useState({
    isFirstLoad: true,
    order: 'asc',
    orderBy: orderColumn,
    selected: [],
    page: 0,
    rowsPerPage: noPagination ? data.length : rowsPerPageProps || 10,
  });

  const { isFirstLoad, order, orderBy, selected, rowsPerPage, page } = state;

  const displayData = noPagination
    ? [...data].sort(getSorting(order, orderBy))
    : [...data]
        .sort(getSorting(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  /* 
  Set empty rows = 0 if and only if (iff):
  1. forced no pagination => noPagination = true
  or
  2. forced no empty rows => noEmptyRows = true 
  */
  const emptyRows =
    noPagination || noEmptyRows
      ? 0
      : rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  useEffect(() => {
    const {
      order: orderParams,
      orderBy: orderByParams,
      selected: selectedParams,
      page: pageParams,
      rowsPerPage: rowsPerPageParams,
    } = getTableParams(name);

    setState({
      isFirstLoad: false,
      order: orderParams || order,
      orderBy: orderByParams || orderBy,
      selected: selectedParams || selected,
      page: pageParams || page,
      rowsPerPage: rowsPerPageParams || rowsPerPage,
    });

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isFirstLoad && name === 'supplier-table')
      setLSItem(keysLS.supplierListTableParams, JSON.stringify(state));
    // eslint-disable-next-line
  }, [state]);

  const handleRequestSort = (event, property) => {
    const orderByVal = property;
    let orderVal = 'desc';

    if (orderBy === property && order === 'desc') {
      orderVal = 'asc';
    }

    if (handleCustomSort) handleCustomSort(orderByVal === 'jobNo' ? 'jobId' : orderByVal, orderVal);

    setState({ ...state, order: orderVal, orderBy: orderByVal });
    handleSort(orderByVal, orderVal.toUpperCase());
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setState({
        ...state,
        selected: data.map((n) => n.id),
      });
      setState({ ...state, selected: [] });
    }
  };

  const handleClick = (columnId) => () => {
    onRowClick && onRowClick(columnId);
  };

  // const handleToggleClick = (event, columnId) => {
  //   const selectedIndex = selected.indexOf(columnId);
  //   let newSelected = [];

  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selected, columnId);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selected.slice(1));
  //   } else if (selectedIndex === selected.length - 1) {
  //     newSelected = newSelected.concat(selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selected.slice(0, selectedIndex),
  //       selected.slice(selectedIndex + 1)
  //     );
  //   }

  //   setState({ ...state, selected: newSelected });
  // };

  const handleChangePage = (pageVal) => {
    setState({ ...state, page: Number(pageVal) });
    onChangePage(pageVal);
  };

  const handleChangeRowsPerPage = (event) => {
    setState({ ...state, rowsPerPage: Number(event.target.value), page: 0 });
    onChangeRowsPerPage(Number(event.target.value));
  };

  const isSelected = (columnId) => selected.indexOf(columnId) !== -1;

  return (
    <TableContainer component={Box} className={classes.root}>
      <MuiTable className={classes.table} aria-labelledby='tableTitle'>
        <TableHead
          data={{
            className: classes.head,
            columnData,
            numSelected: selected.length,
            order,
            orderBy,
            orderColumn,
            rowCount: data.length,
            tableData: data,
            positionExpand,
            usingExpandLayout,
          }}
          func={{
            onRequestSort: handleRequestSort,
            onSelectAllClick: handleSelectAllClick,
            toolMenu,
            handleSort,
          }}
          usingForFactoryAudit={usingForFactoryAudit}
          titleTableHead={titleTableHead}
          showingTableHeader={showingTableHeader}
        />
        <TableBody
          data={{
            className: classes.body,
            columnData,
            displayData,
            emptyRows,
            hover,
            keyColumn,
            tableData: data,
            positionExpand,
            usingExpandLayout,
          }}
          func={{ isSelected, handleClick, toolColumn }}
          usingCheckbox={usingCheckbox}
          usingForFactoryAudit={usingForFactoryAudit}
          customEmptyTableBody={customEmptyTableBody}
          defaultExpanded={defaultExpanded}
        />
      </MuiTable>
      {!noPagination && data.length > 0 && (
        <TablePagination
          data={{
            columnData,
            page,
            rowsPerPage,
            rowsPerPageOptions: getRowsPerPageOptions(100),
            tableData: data,
          }}
          func={{
            onChangePage: handleChangePage,
            onChangeRowsPerPage: handleChangeRowsPerPage,
          }}
          {...paginationProps}
        />
      )}
    </TableContainer>
  );
};

Table.defaultProps = {
  columnData: [],
  data: [],
  keyColumn: '',
  name: '',
  hover: true,
  noEmptyRows: true,
  noPagination: false,
  orderColumn: '',
  paginationProps: {},
  rowsPerPage: 10,
  onRowClick: null,
  toolColumn: null,
  toolMenu: null,
  usingCheckbox: false,
  usingForFactoryAudit: false,
  titleTableHead: undefined,
  handleCustomSort: () => {},
};

Table.propTypes = {
  classes: PropTypes.object.isRequired,
  columnData: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  keyColumn: PropTypes.string,
  name: PropTypes.string,
  hover: PropTypes.bool,
  noEmptyRows: PropTypes.bool,
  noPagination: PropTypes.bool,
  orderColumn: PropTypes.string,
  paginationProps: PropTypes.object,
  rowsPerPage: PropTypes.number,
  onRowClick: PropTypes.func,
  toolColumn: PropTypes.func,
  toolMenu: PropTypes.func,
  usingCheckbox: PropTypes.bool,
  usingForFactoryAudit: PropTypes.bool,
  titleTableHead: PropTypes.string,
  handleCustomSort: PropTypes.func,
};

export default withStyles(styles)(Table);
